import { render, staticRenderFns } from "./ProjectReserves.vue?vue&type=template&id=94ed97e4&"
import script from "./ProjectReserves.vue?vue&type=script&lang=js&"
export * from "./ProjectReserves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports